module.exports = __webpack_public_path__ + "static/githubuniverse-2c1f418fbbc428fe5416302e735c1e45.png";